import { styled } from 'styled-components';
import THEME from '../../../theme.js';
export const IconWrapper = styled.div `
  display: inline-block;
  position: relative;
  margin-right: 10px;
  padding: 6px;

  svg {
    height: 35px;
    width: 35px;
  }
`;
export const ColorText = styled.div `
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 0.7em;
  font-weight: 900;
  color: ${(props) => props.negative ? THEME.COLOR_SECONDARY : THEME.COLOR_PRIMARY};
`;
export const StyledColor = styled.div `
  display: inline-block;
  position: relative;
  height: 120px;
  width: 120px;
  margin-right: 10px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 3px;

  span {
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 0.7em;
    font-weight: 900;
    color: ${(props) => props.negative ? THEME.COLOR_SECONDARY : THEME.COLOR_PRIMARY};
  }
`;
//# sourceMappingURL=styles.js.map